import { css } from "@emotion/react";
import { bpoints } from "../../Utils";

export function loaderCSS() {
    return css`
        position: fixed;
        top: 0;
        left: 0;

        width: 100vw;
        height: 100%;

        background-color: rgba(15, 23, 42, 0.55);
        backdrop-filter: blur(2px);

        z-index: 9999 !important;

        display: flex;
        justify-content: center;
        align-items: center;

        .loader-svg-wrap {
            display: flex;
            align-items: center;
            justify-content: center;
            animation: loader-breathe 2.6s ease-in-out infinite;
        }

        .loader-svg {
            width: 180px;
            height: auto;
            display: block;
            overflow: visible;
        }

        .loader-path {
            stroke-dasharray: 600;
            stroke-dashoffset: 600;
            animation: loader-draw 2.6s ease-in-out infinite;
        }

        @keyframes loader-draw {
            0% {
                stroke-dashoffset: 600;
            }
            45% {
                stroke-dashoffset: 0;
            }
            55% {
                stroke-dashoffset: 0;
            }
            100% {
                stroke-dashoffset: 600;
            }
        }

        @keyframes loader-breathe {
            0%, 100% {
                transform: scale(0.96);
                opacity: 0.85;
            }
            50% {
                transform: scale(1.02);
                opacity: 1;
            }
        }

        .Center {
            font-weight: 500;
            background: linear-gradient(91deg, #00BA6E 0%, #32B8DF 100%);
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            font-size: 1.4rem;
            margin-top: 1.2rem;

            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;

            span {
                text-align: center;
            }

            @media (max-width: ${bpoints.mobile.w}px) {
                font-size: calc(0.9rem + 1vw);
            }
        }
    `;
}
